import { render, staticRenderFns } from "./SystemUpdateAlert.vue?vue&type=template&id=cb164f1c&scoped=true"
import script from "./SystemUpdateAlert.vue?vue&type=script&lang=js"
export * from "./SystemUpdateAlert.vue?vue&type=script&lang=js"
import style0 from "./SystemUpdateAlert.vue?vue&type=style&index=0&id=cb164f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb164f1c",
  null
  
)

export default component.exports